import { AuthUser, AuthUserType, User } from "./types"

export const mapAuthUserType = (user?: User): AuthUserType => {
  switch (user?.kind?.tag) {
    case `broker`:
      return `distributor`
    case `flocker`:
      return `admin`
    case `customer`:
      return `customer`
    case `claims_admin`:
      return `claims_admin`
    case `carrier`:
      return `carrier`
    default:
      return `customer`
  }
}

export const mapAuthUser = (user?: User): AuthUser | null =>
  user
    ? {
        id: user.id,
        // expiresAt: ``,
        type: mapAuthUserType(user),
        ownerId: mapOwnerId(user),
      }
    : null

const mapOwnerId = (user?: User) => {
  switch (user?.kind?.tag) {
    case `broker`:
      return user.kind.brokerId
    case `customer`:
      return user.kind.customerId
    case `claims_admin`:
      return user.kind.claimsAdminId
    case `carrier`:
      return user.kind.carrierId
    case `flocker`:
      return null
    default:
      throw new Error(`Could not decode ownerId`)
  }
}
